import {
  TextCountingNumber,
  TextHighlight,
  TextSlidingNumber,
  TextSplitting,
} from "./parts";

const Text = {
  Splitting: TextSplitting,
  CountingNumber: TextCountingNumber,
  SlidingNumber: TextSlidingNumber,
  Highlight: TextHighlight,
};

export default Text;
